import { render, staticRenderFns } from "./OneTimeRideList.vue?vue&type=template&id=6c13b092"
import script from "./OneTimeRideList.vue?vue&type=script&lang=js"
export * from "./OneTimeRideList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports